import ActiveSessions from "./ActiveSessions";

export default ActiveSessions;